var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresentation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.333 6h29.334C35.389 6 36 6.61 36 7.332c0 .777-.611 1.332-1.333 1.332H5.333C4.556 8.664 4 8.11 4 7.332 4 6.611 4.556 6 5.333 6zm.445 4.44h2.666v11.988c0 .278.167.444.445.444h22.167c.277 0 .444-.166.444-.444V10.44h2.667v11.988a3.105 3.105 0 01-3.111 3.108h-9.778v2.609l4.055 4.052c.556.5.556 1.332 0 1.831-.5.555-1.333.555-1.889 0l-3.5-3.496-3.5 3.496c-.5.555-1.333.555-1.833 0a1.215 1.215 0 010-1.831l4.056-4.052v-2.608H8.889a3.105 3.105 0 01-3.111-3.109V10.44z"
  })));
}
export default SvgPresentation;